import { WorkRule, WorkRuleGeneralInput } from './@types/WorkRuleModel';
export class WorkRuleRepository {
    private httpService: IHttpService;
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getWorkRules(): Promise<WorkRule[]> {
        try {
            const response = await this.httpService.get<TKResponse<WorkRule[]>>('/work_rules');
            return response.data
                .map((work_rule: WorkRule) => ({ ...work_rule, id: work_rule.work_rule_id }))
                .sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error('Error al obtener las work_rules:', error);
            throw error;
        }
    }

    async getWorkRuleById(workRuleId: number): Promise<WorkRule> {
        try {
            const response = await this.httpService.get<TKResponse<WorkRule>>(`/work_rules/${workRuleId}`);
            return { ...response.data, id: response.data.work_rule_id };
        } catch (error) {
            console.error(`Error al obtener la work_rule con ID ${workRuleId}:`, error);
            throw error;
        }
    }

    async createWorkRule(data: WorkRuleGeneralInput): Promise<{ data: WorkRule; status: number | string }> {
        try {
            const response = await this.httpService.post<TKResponse<WorkRule>, WorkRuleGeneralInput>('/work_rules', { data });
            return { data: { ...response.data, id: response.data.work_rule_id }, status: response.status };
        } catch (error) {
            console.error('Error al crear la work_rule:', error);
            throw error;
        }
    }

    async updateWorkRule(workRuleId: number, data: Partial<WorkRuleGeneralInput>): Promise<{ data: WorkRule; status: number | string }> {
        try {
            const response = await this.httpService.patch<TKResponse<WorkRule>, Partial<WorkRuleGeneralInput>>(`/work_rules/${workRuleId}`, { data });
            return { data: { ...response.data, id: response.data.work_rule_id }, status: response.status };
        } catch (error) {
            console.error(`Error al actualizar la work_rule con ID ${workRuleId}:`, error);
            throw error;
        }
    }
    async deleteWorkRule(workRuleId: number): Promise<void> {
        try {
            await this.httpService.delete<void>(`/work_rules/${workRuleId}`);
        } catch (error) {
            console.error(`Error al eliminar la work_rule con ID ${workRuleId}:`, error);
            throw error;
        }
    }
}
